// 

// import { Cookie } from "../../constants/base/utils";
// import { GetItemFromStorage } from "../../custom_hooks/useStorage";
import axios from "axios";
import { config } from "../constant";
import { Cookie } from "../custom_hooks/useStorage";
import { encryptAES } from "../constant/utils";
// import { loginConfig } from "../../components/login/LoginConstant";

export class LoginService {
  public static async login(data: any) {
    // const url: string = "https://stageccaas.unifiedring.co.uk/core_service/v1/login";
    // const url: string = "http://10.22.7.115:3000/core_service/v1/login";
  //  let  LOGIN_API = "https://urapi.worktual.co.uk/urauth/v1/token/create_jwt";

    const userName = await encryptAES(data?.username);

    const pass = await encryptAES(data?.password);
    let body = { ...data };
    if (import.meta.env.VITE_APP_ENV == "qa") {
      body = {
        ...data, "username": userName, "password": pass
      }
    }
     
    const url: string = config().LOGIN_API;
    const _body = { ...body, isForceLogin: true ,loginCheck:'CVM'}
    return axios
      .post(url, _body, {
        headers: {
          // appId: "844239",
          // appSecret: "kU9IPc0C65",
          appId: config().APPID,
          appSecret: config().AppSECRET,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  // public static async logOut() {
  //   const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
  //   // const token: any = Cookie.get();
  //   const url: string = config().LOG_OUT_API;
  //   return axios
  //     .get(url, {
  //       headers: {
  //         appId: config().APPID,
  //         appSecret: config().AppSECRET,
  //         Authorization: accessToken,
  //       },
  //     })
  //     .then((response: any) => {
  //       return response;
  //     });
  // }

  // public static async forgotPassword(data: any) {
  //   const resetPass: any = loginConfig().RESET_PASS_API;
  //   return axios.post(resetPass, data).then((response: any) => {
  //     return response;
  //   });
  // }

  //Access Token
  public static getToken() {
    const token: any = Cookie.get();
    let _token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImtyaXNobmFrdW1hci5zQHZlY3RvbmUuY29tIiwicGFzc3dvcmQiOiJrcmlzaG5hQDg2NiIsImRldmljZUlkIjoiMTU1LWhkbmRuLXdldXdpZWUiLCJzaXBMb2dpbklkIjoiNTM2NCIsInJvbGVJZCI6NCwiZG9tYWluSWQiOjMzMjgsImV4dCI6MjA5LCJjb21wYW55SWQiOjMzNjIsImVuZXRlcHJpc2VpZCI6ODAzMiwiaG9zdEFkZHJlc3MiOiI4MDMyLnVyY2hhdC51bmlmaWVkcmluZy5jby51ayIsIm9yZGVySWQiOjExMDE4LCJkaXJVc2VySWQiOjMyNjI0LCJpYXQiOjE2MjM3NTQ3ODd9.cR2-rh9bxex3riXVPlHW69gNRqZzDR8Tt6ewhuC9eXg";
    if (token && typeof token.ssoToken != "undefined" && token.ssoToken) {
      _token = token.ssoToken;
    }
    return _token;
  };

 

  public static async socialMediaLogin(data:any) {
    const accessToken = this.getToken();
    // const token: any = Cookie.get();
    const url: string = `${config().MYACCOUNTSERVICE_URL}/login/social_account_login`;
    return axios
      .post(url,data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: accessToken,
        },
      })
      .then((response: any) => {
        return response;
      });
  }

}
